import { createBrowserRouter } from "react-router-dom";
import { Home } from "./Home";
import { Playground } from "./Playground";
import { Arena } from "./Arena";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/playground",
    element: <Playground />,
  },
  {
    path: "/arena",
    element: <Arena />,
  },
]);
